import React from 'react';
import { Id, toast, ToastContainer, ToastPosition, TypeOptions } from 'react-toastify';
import { CloseToast } from 'src/assets/icons';
import { Col } from 'src/common';
import './toast.scss';

export type NotifyProps = {
  customId?: string;
  children: string;
  autoClose: number | false;
  position?: NotifyPosition;
  type?: TypeOptions;
  isRevampCart?: boolean;
  icon?: React.ReactNode;
};

export enum NotifyPosition {
  top_center = 'top-center',
}

const positionMap = new Map<NotifyPosition, ToastPosition>([
  [NotifyPosition.top_center, toast.POSITION.TOP_CENTER],
]);

let toastId: Id | undefined = undefined;

export const notify = (props: NotifyProps) => {
  if (!toastId) {
    toastId = toast(props.children, {
      toastId: props.customId,
      position: props.position ? positionMap.get(props.position) : toast.POSITION.TOP_RIGHT,
      type: props?.type,
      className: props?.type ? undefined : props.isRevampCart ? 'revamp-cart' : 'simple-toast',
      closeButton: (
        <Col className="close-toast-icon">
          <CloseToast />
        </Col>
      ),
      pauseOnFocusLoss: false,
      icon: props.icon,
      autoClose: props.autoClose,
      closeOnClick: true,
      hideProgressBar: true,
      onClose: () => (toastId = undefined),
    });

    return;
  }

  toast.update(toastId, {
    autoClose: props.autoClose,
    render: props.children,
    onClose: () => (toastId = undefined),
  });
};

export const Toast = () => <ToastContainer limit={1} className="notification-toast" />;
